import React from 'react'

import { Content } from 'sdk/components/content/Content'
import { Accordion } from 'components/accordion/Accordion'
import { AccordionItem } from 'components/accordion/AccordionItem'
import { Text, TextName } from 'sdk/text/Text'

import type { SdkSystemRequirementCmsContent } from 'core/services/cms/interfaces'

import styles from './style.module.scss'

interface SystemRequirementsAccordionProps {
  requirements: SdkSystemRequirementCmsContent[]
}

export const SystemRequirementsAccordion: React.FC<SystemRequirementsAccordionProps> = ({ requirements }) => (
  <Content element='section' className={styles.systemRequirementsAccordion}>
    <Accordion>
      {requirements.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          description={(
            <ul>
              {item.items.map((requirement) => (
                <li key={requirement}>
                  <Text type={TextName.Subtext}>{requirement}</Text>
                </li>
              ))}
            </ul>
          )}
        />
      ))}
    </Accordion>
  </Content>
)
